module.exports = __webpack_public_path__ + "static/waiting-in-white_2008-c0409e7556bd76dc5794439e5005100e.jpg";